import moment from 'moment'
import bignumber from '@/utils/bignumber'
import { BIGNUMBER_ZERO } from '@/constants'
import { ToastProgrammatic as Toast } from 'buefy'

export const numberWithComma = function (value, format = 8) {
  try {
    if (typeof value === 'string' || typeof value === 'number') {
      value = bignumber(value)
    }
    if (!value || value.isZero()) return 0
    const stringNumber = value.toString()
    const numeralString = stringNumber.split('.')[0]
    if (value.isLessThan(bignumber('0.0000001'))) { // In case value less than 0.0000001 will show value without formatting.
      return value.toFormat()
    }
    const numOfDecimal = numeralString.length <= format ? format - numeralString.length : 0 // In case value more than 99,999,999 will show value without decimal.
    return value.toFormat(numOfDecimal)
  } catch (e) {
    return BIGNUMBER_ZERO.toFormat(format)
  }
}

export const toFixedDecimal = (value, format = 2) => {
  if (typeof value === 'string' || typeof value === 'number') {
    value = bignumber(value)
  }
  if (!value || value.isZero()) return 0
  return value.toFormat(format)
}

export const formatDate = (value, format = 'DD-MM-YYYY') => {
  if (moment(value, moment.ISO_8601).isValid() || moment(value, 'YYYY-MM-DD', true).isValid()) {
    return moment(value).format(format)
  }
  return value
}

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = function () {
      resolve(reader.result)
    }
    reader.onerror = function (error) {
      reject(error)
    }
  })
}

export const resizeImage = (base64Str, maxWidth = 1024, maxHeight = 1024) => {
  return new Promise((resolve) => {
    let img = new Image()
    img.src = base64Str
    img.onload = () => {
      let canvas = document.createElement('canvas')
      const MAX_WIDTH = maxWidth
      const MAX_HEIGHT = maxHeight
      let width = img.width
      let height = img.height

      if (width > height) {
        if (width > MAX_WIDTH) {
          height *= MAX_WIDTH / width
          width = MAX_WIDTH
        }
      } else {
        if (height > MAX_HEIGHT) {
          width *= MAX_HEIGHT / height
          height = MAX_HEIGHT
        }
      }
      canvas.width = width
      canvas.height = height
      let ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0, width, height)
      resolve(canvas.toDataURL())
    }
  })
}

export const base64toBlob = (b64Data) => {
  return new Promise((resolve) => {
    fetch(b64Data)
      .then(res => res.blob())
      .then(blob => {
        const file = new File([blob], 'filename.jpeg', { type: 'image/jpeg' })
        resolve(file)
      })
  })
}

export const showToastError = (e) => {
  if (e.response && e.response.data && e.response.data.message) {
    let message = e.response.data.message
    if (typeof message === 'object') {
      message = message.reduce((acc, cur) => (`${acc} ${cur}`))
    }
    Toast.open({
      message: message,
      type: 'is-danger',
      duration: 5000
    })
  } else {
    Toast.open({
      message: e.message,
      type: 'is-danger',
      duration: 5000
    })
  }
}

export const calTotalKULToken = (rewards) => {
  if (rewards && rewards.length) {
    return rewards.reduce((accumulator, current) => {
      return accumulator + parseInt(current.amount)
    }, 0)
  } else {
    return 0
  }
}

export const displayKYCStatus = (status) => {
  if (status === 'UNVERIFIED') {
    return 'Unverified'
  } else if (status === 'VERIFYING') {
    return 'Pending'
  } else if (status === 'REQUEST_CHANGE') {
    return 'Incorrect Information'
  } else if (status === 'APPROVED') {
    return 'Verified'
  } else if (status === 'REJECTED') {
    return 'Reject KYC'
  } else {
    return status
  }
}

export const parseStringToDate = (data) => {
  for (const [key, value] of Object.entries(data)) {
    if (moment(value, moment.ISO_8601).isValid()) {
      data[key] = new Date(Date.parse(value))
    }
  }
  return data
}

export const displayFromKeyToText = (value, dataList, language) => {
  const result = dataList && dataList.find(p => p.key === value)
  if (result) {
    return result[language === 'th' ? 'th' : 'en']
  }
  return value
}

export const sortDataByLanguage = (dataList, language) => {
  if (Array.isArray(dataList)) {
    language = language === 'th' ? 'th' : 'en'
    const newList = dataList
    newList.sort((a, b) => a[language].localeCompare(b[language], language))
    return newList
  }
  return dataList
}

export const getNetworkByChainId = (chainId) => {
  switch (`${chainId}`) {
    case '42':
      return 'kovan'
    case '1':
      return 'main'
    default:
      return 'main'
  }
}

export const padNumber = (value, targetLength = 2) => {
  return value.toString().padStart(targetLength, '0')
}

export const shortenHex = (value, format = 5) => {
  if (!value) return ''
  const zeroXLength = 2
  const first = value.substr(0, format + zeroXLength)
  const last = value.substr(value.length - format, value.length)
  return `${first}...${last}`
}

export const convertDatetoUTCStartOfDay = (time) => {
  return moment.utc(moment(time).startOf('day')).format()
}

export const convertDatetoUTCEndOfDay = (time) => {
  return moment.utc(moment(time).endOf('day')).format()
}

export const timestampToDate = (value) => {
  if (value) {
    if (value.toString().length === 10) {
      value = value * 1000
    }
    return moment(value)
  }
  return moment(value)
}



// WEBPACK FOOTER //
// ./src/utils/helper.js